import ResourcesField from '@apps/subscriptions/admin/components/resourcesfield'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Edit extends React.Component {

  static contextTypes = {
    modal: PropTypes.object,
    router: PropTypes.object
  }

  static propTypes = {
    service: PropTypes.object
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form {...this._getForm()} />
  }

  _getForm() {
    const { service } = this.props
    return {
      title: 't(Manage Resources)',
      method: 'PATCH',
      endpoint: `/api/admin/subscriptions/services/${service.id}/edit`,
      action: `/api/admin/subscriptions/services/${service.id}`,
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { label: 'Metered Resources', name: 'resources', type: ResourcesField, required: true }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleSuccess(service) {
    this.context.modal.close()
  }

}

export default Edit
